export default function sumOfSoldBonStock(allSold) {
  const values = Object.values(allSold);
  const sumOfValues = values.reduce((accumulator, currentValue) => accumulator + currentValue, 0);
  return sumOfValues;
}
